import { Flow_0_0_2 } from '@flexus/core';

export const BET_26: Flow_0_0_2 = {
	id: '26',
	name: 'TL_work_complete',
	itemType: 'flow',
	header: {
		title: '',
		controls: () => () => []
	},
	footer: {
		type: 'node_nav'
	},
	instructions: {
		editRoles: {
			0: '--'
		},
		viewRoles: {
			0: 'Wait for SP invoice'
		}
	},
	startNode: '',
	nodes: {}
};
